import React, { useContext } from "react";
import {elements} from "./utils"
import { VehicleContext } from "../../../../contexts/VehicleContext";
import pen from '../../../../assets/router/edit-pen-white.svg'
import cross from '../../../../assets/orders/cross.svg'
import { 
    Container,
    HeaderDiv,
    HeaderText,
    Text,
    TextLabel,
    GridContainer, 
    CloseDiv,
    CloseImg,
    OptionsDiv,
    ButtonOfSectionText,
    ButtonOfSection,
    IconImg,
    LineDiv,
} from "./style";
import ModalContext from "../../../../contexts/ModalContext";
import axios from "axios";
import { ButtonCreate } from "../../../../components/styles/subheader-style";
import ModalTest from "../../../BaseModal";
import { useNavigate } from "react-router-dom";


export interface VehicleInterface {
    plate: string,
    model: string,
    year: number,
    capacity: number,
    size: number,
    restriction: string
}

const VehicleDetail = ()=>{
    const navigate = useNavigate()
    const {vehicle} = useContext(VehicleContext);
    const {setModalActive, setModalSection} = useContext(ModalContext)


    const vehicleData: VehicleInterface = {
        plate: vehicle?.plate || '',
        model: vehicle?.model || '',
        year: vehicle?.year || 0,
        capacity: vehicle?.capacity ||0,
        size: vehicle?.size || 0,
        restriction: vehicle?.restriction || ''
    }
    
    


const close = ()=>{
    navigate('..')
}   


const handleEditModal = ()=>{
    navigate('/panel/equipment/create')
}

    return(
        <ModalTest>
        <Container>
            <GridContainer>
                <HeaderDiv style={{gridArea: `titleNew`}}>
                <HeaderText>{vehicle?.model + ' ' + vehicle?.plate}</HeaderText>
                <CloseDiv onClick={()=>close()}>
                    <CloseImg src={cross}></CloseImg>
                </CloseDiv>
                </HeaderDiv>
                {
                   elements.map((element, index)=>{
                    return(
                        <>
                        <TextLabel style={{gridArea : element.gridArea + 'Label'}}> {element.label}</TextLabel>
                        <Text style={{gridArea : element.gridArea}}>{vehicleData[element.field]}</Text>
                        </>
                    )
                   }) 
                }
                <LineDiv></LineDiv>
            </GridContainer>
            <OptionsDiv>
                <ButtonCreate onClick={()=>handleEditModal()}>
                    <img  src={pen}></img>
                    Editar veículo
                </ButtonCreate>
            </OptionsDiv>
        </Container>
        </ModalTest>
    )
}

export default VehicleDetail
